import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const InsightIcon = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    d='M12.1641 3.73691C12.5637 3.73691 12.8927 3.40788 12.8927 3.00833V0.728581C12.8927 0.329036 12.5637 0 12.1641 0C11.7646 0 11.4355 0.329036 11.4355 0.728581V3.00833C11.4355 3.40788 11.7646 3.73691 12.1641 3.73691Z'
    fill='#AE7F26'
  />
  <Path
    d='M5.92298 5.89857C6.20501 5.61654 6.20501 5.14648 5.92298 4.86445L4.3013 3.24277C4.01927 2.96074 3.54922 2.96074 3.26719 3.24277C2.98516 3.5248 2.98516 3.99486 3.26719 4.27689L4.88887 5.89857C5.02988 6.03958 5.2179 6.11009 5.40592 6.11009C5.59395 6.11009 5.78197 6.03958 5.92298 5.89857Z'
    fill='#AE7F26'
  />
  <Path
    d='M21.0607 3.26816C20.7786 2.98613 20.3086 2.98613 20.0266 3.26816L18.4049 4.88984C18.1229 5.17187 18.1229 5.64193 18.4049 5.92396C18.5459 6.06497 18.7339 6.13548 18.9219 6.13548C19.11 6.13548 19.298 6.06497 19.439 5.92396L21.0607 4.30228C21.3427 3.99674 21.3427 3.5502 21.0607 3.26816Z'
    fill='#AE7F26'
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M9.26648 20C9.26648 20.5523 9.71419 21 10.2665 21H13.6915C14.2438 21 14.6915 20.5523 14.6915 20V16.9804C14.6915 16.9704 14.6916 16.9604 14.6919 16.9505C14.7031 16.5845 14.9171 16.2573 15.2271 16.0591C16.8945 14.9933 18 13.1258 18 11C18 7.68629 15.3137 5 12 5C8.68629 5 6 7.68629 6 11C6 13.1108 7.08999 14.967 8.73782 16.0365C9.05249 16.2408 9.26648 16.5785 9.26648 16.9537V20ZM13.2525 16.4291C13.4139 15.7143 13.8766 15.1421 14.4192 14.7953C15.6737 13.9934 16.5 12.5927 16.5 11C16.5 8.51472 14.4853 6.5 12 6.5C9.51472 6.5 7.5 8.51472 7.5 11C7.5 12.5816 8.31473 13.9737 9.55445 14.7783C10.0954 15.1294 10.5548 15.7058 10.7102 16.4241L13.2525 16.4291ZM13.1915 17.929L10.7665 17.9242V19.5H13.1915V17.929Z'
    fill='#AE7F26'
  />
  <Path
    d='M11 21H13C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21Z'
    fill='#AE7F26'
  />
</Svg>;

export default InsightIcon;
